import { PARTNERS_COVERAGE_COLUMN_KEYS } from '../../../../configs/coverageTables'

import styles from './CoverageTable.module.scss'

/**
 * Shared by the column header and by every coverage table, so all of them
 * keep the same column widths under `table-layout: fixed`.
 */
export const CoverageTableColgroup = () => {
  return (
    <colgroup>
      <col className={styles.labelCol} />
      {PARTNERS_COVERAGE_COLUMN_KEYS.map((columnKey) => (
        <col key={columnKey} />
      ))}
    </colgroup>
  )
}
